<template>
  <IconButton
    :class="[
      'h-8',
      isVertical ? 'w-10' : uniformWidth && showCount ? 'w-15' : 'w-7.25',
      !isVertical && showCount && uniformWidth ? 'justify-end' : '',
    ]"
    :size="'auto'"
    :background-class="backgroundClass"
    @click="(event: MouseEvent) => emit('click', event)"
  >
    <div
      class="flex"
      :class="[
        isVertical
          ? 'flex-col items-center justify-center'
          : [
              'items-center',
              iconPosition === 'right' ? 'flex-row-reverse' : '',
              uniformWidth ? 'w-full' : '',
            ],
      ]"
    >
      <IconCustom :ligature="iconLigature" size="16" :class="iconColorClass"></IconCustom>
      <div
        class="flex items-center select-none font-sans text-[10px] leading-none tabular-nums"
        :class="[
          iconColorClass,
          isVertical ? 'mt-1.25' : iconPosition === 'right' ? 'pr-1.25' : 'pl-1.25',
        ]"
        v-if="showCount"
      >
        <div class="flex flex-col items-center">
          <span>{{ count }}/{{ volumeCount }}</span>
        </div>
      </div>
    </div>
  </IconButton>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import IconButton from '@/components/IconButton.vue'
import IconCustom from '@/components/IconCustom.vue'
import type { IconName } from '@/icons'

interface Props {
  iconLigature: IconName
  count: number
  volumeCount: number | undefined
  showCount: boolean
  backgroundClass?: string
  iconColorClass?: string
  iconPosition?: 'left' | 'right'
  uniformWidth?: boolean
  orientation?: 'horizontal' | 'vertical'
}

const props = withDefaults(defineProps<Props>(), {
  iconColorClass: 'text-text-on-dark',
  iconPosition: 'left',
  uniformWidth: false,
  orientation: 'horizontal',
})

const isVertical = computed(() => props.orientation === 'vertical')

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()
</script>
